"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getCardUtilityClass = getCardUtilityClass;

var _utils = require("@mui/utils");

var _generateUtilityClass = _interopRequireDefault(require("../generateUtilityClass"));

function getCardUtilityClass(slot) {
  return (0, _generateUtilityClass.default)('MuiCard', slot);
}

const cardClasses = (0, _utils.unstable_generateUtilityClasses)('MuiCard', ['root']);
var _default = cardClasses;
exports.default = _default;